import Store from './Store';

export default Store;



// WEBPACK FOOTER //
// ./src/pages/Store/index.ts